<template>
    <div class="container">
        <div class="row justify-content-center my-3">
            <div class="col-12 col-lg-9">
                <p style="color: #FF3232;">
                    I don't know if anyone needs TTK&STK for Undead Siege mode but if anyone interested in testing the stats yourself, I will add it. Give me a heads up first if you decide to help.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>